import {create} from 'zustand';

/**
 * Bridges the DOCX import dialog and the ProseMirror editor.
 *
 * After a successful import, the dialog stores the parsed TipTap content here
 * along with the target reportId.  When the editor mounts and syncs for the
 * first time it reads this store, injects the content via a ProseMirror
 * transaction, then clears the store so subsequent navigations are unaffected.
 *
 * `references` holds the list of reference entries with URLs that were parsed
 * from the DOCX, so the editor can later poll the backend and inject reference
 * marks once the async embedding + vector search is complete.
 *
 * `referenceImportStatus` tracks the async reference resolution lifecycle:
 *   'idle'       — no reference import in progress
 *   'processing' — backend is resolving references
 *   'done'       — references are ready to be injected
 *   'failed'     — backend encountered an error
 */
const useImportedContentStore = create((set) => ({
    content: null,
    reportId: null,
    references: [],
    referenceImportStatus: 'idle',

    setImportedContent: (reportId, content, references = []) => set({reportId, content, references}),

    setReferenceImportStatus: (status) => set({referenceImportStatus: status}),

    clear: () => set({content: null, reportId: null, references: [], referenceImportStatus: 'idle'}),
}));

export default useImportedContentStore;
